const Tag = ({ children }) => (
  <span className="px-2.5 py-1 text-xs rounded-md border border-border text-muted font-mono">
    {children}
  </span>
);

export default Tag;
